// tslint:disable
/**
 * Ux
 * insightux api
 *
 * The version of the OpenAPI document: 3.42
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
export function CustomFieldFromJSON(json) {
    return {
        'name': !exists(json, 'name') ? undefined : json['name'],
        'values': !exists(json, 'values') ? undefined : json['values'],
    };
}
export function CustomFieldToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    return {
        'name': value.name,
        'values': value.values,
    };
}
